// eslint-disable-next-line import/no-unresolved, import/extensions
import Privacy from './Privacy';

export default Privacy;
